export const whoiskelvin = `

#### How would you describe yourself?
I'm Kelvin, and I've been living with type 1 diabetes for over two decades now. My parents are from Suriname, but I was born and raised in Rotterdam, the Netherlands. I enjoy being creative and have a bachelor's degree in chemistry, but after graduating, I became a medical doctor.
<br />
<br />

#### Can you tell us something special about you that not many people know?
I like to dance a specific partner dance called Urban Kiz.
<br />
<br />

#### What were the biggest challenges you faced before using a closed-loop system?
I used to work evening and night shifts, which really threw me off balance. I would struggle for days afterward to get things back on track. I've never been a very scheduled eater—and still find it difficult—so that was always a weak spot, especially combined with the shifts.
<br />
<br />

#### Can you tell us about your diabetes journey and what led you to open-source looping?
I started experimenting with coding during the start of the COVID-19 pandemic. There wasn't much else to do, and it seemed like an interesting way to spend my free time. That new hobby led me to discover open-source looping in 2021. I was amazed by how much of a positive impact it had on my life—all thanks to the hard work of software developers who contributed to creating open-source solutions. As a result, I transitioned from working in healthcare to health tech, and I've been loving it ever since.
<br />
<br />

#### What are the biggest benefits you've experienced with open-source looping?
I sleep better, I feel better, and I'm able to go for 10km runs (and longer) without having to worry about my diabetes.
<br />
<br />

#### Have you faced any major issues with your open-source loop setup? How did you solve them?
Yes, in the first couple of weeks, my glucose levels were all over the place, and my HbA1c actually got worse. That was because I had to get used to a lot of things all at once—a glucose sensor, pump, infusion sets, understanding the algorithm, adjusting basals, etc. I just kept going because I saw the system's potential, and after a while, and with the help of <a href="/blog/details/Introducing-Hylke-Nicola" target="_blank">Hylke Nicola</a> as my coach, I started to understand how things work.

Thanks to the challenges I went through, and my background as a medical doctor, I truly believe that while many people get the hang of it quickly, others really struggle and need support to get things running smoothly.
<br />
<br />

#### What's your advice for someone struggling with their open-source loop settings?
Take it step by step and be patient. Hard work pays off.
<br />
<br />

#### Where do you see the future of diabetes in 10 years?
I believe diabetes will be a fully solved digital problem. With the right combination of software, hardware, an online community, and if needed a coach, it'll take very little effort to achieve optimal glucose levels.
And unlike the current situation, I believe the solution should also be accessible to people who aren't tech-savvy and those who lack the means to obtain the necessary equipment. That's why we created this platform.
<br />
<br />

<!-- blog-contact-footer -->
`;
